export default function imageCar() {
    const blocks = document.querySelectorAll('[data-image-car]')
    if (!blocks.length) return

    const gap = () => parseFloat(getComputedStyle(document.documentElement).fontSize) * 2

    const mobile = () => window.matchMedia('(max-width: 767.98px)').matches

    const place = (root) => {
        if (mobile()) {
            root.querySelectorAll('.image-car__card').forEach((card) => {
                card.style.top = ''
            })
            return
        }
        root.querySelectorAll('.image-car__col').forEach((col) => {
            const cards = [...col.querySelectorAll('.image-car__card')]
            if (!cards.length) return
            const space = col.clientHeight
            const heights = cards.map((card) => card.offsetHeight)
            const slot = (card) => {
                if (!card.dataset.slot) card.dataset.slot = String(Math.random())
                return Number(card.dataset.slot)
            }

            if (cards.length === 1) {
                const room = Math.max(0, space - heights[0])
                cards[0].style.top = `${slot(cards[0]) * room}px`
                return
            }

            const extra = space - heights[0] - heights[1] - gap()
            const before = extra > 0 ? slot(cards[0]) * extra : 0
            cards[0].style.top = `${before}px`
            cards[1].style.top = `${before + heights[0] + gap()}px`
        })
    }

    const show = (el) => el.classList.add('is-in')
    const inView = (el) => {
        const rect = el.getBoundingClientRect()
        return rect.top < window.innerHeight && rect.bottom > 0
    }

    blocks.forEach((el) => {
        place(el)
        el.classList.add('is-ready')
    })
    window.addEventListener('resize', () => blocks.forEach(place))

    if (!('IntersectionObserver' in window)) {
        blocks.forEach(show)
        return
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return
            show(entry.target)
            observer.unobserve(entry.target)
        })
    }, { threshold: 0.15 })

    blocks.forEach((el) => {
        if (inView(el)) show(el)
        else observer.observe(el)
    })
}
